import { computed, Injectable, Signal, TemplateRef, ViewContainerRef } from '@angular/core';

import { PermissionAliasEnum } from '@connect-services/client/sdk/api';
import { SecurityService } from '@connect-services/client/services/security.service';

export enum OperatorEnum {
    AND = 'and',
    OR = 'or',
}

@Injectable({
    providedIn: 'root',
})
export class HasPermissionsService {
    public readonly initialized: Signal<boolean> = computed(() => this.securityService.initialized());

    public constructor(private securityService: SecurityService) {}

    public checkPermissions(
        requiredPermissions: PermissionAliasEnum[],
        operator: OperatorEnum = OperatorEnum.AND,
    ): boolean {
        if (this.securityService.meSignal()?.role?.isAdmin) {
            return true;
        }

        const method = operator === OperatorEnum.AND ? Array.prototype.every : Array.prototype.some;

        return (
            !requiredPermissions.length ||
            method.call(requiredPermissions, (requiredPermission: PermissionAliasEnum) =>
                this.securityService.meSignal()?.role?.permissionAliases.includes(requiredPermission),
            )
        );
    }

    public removeComponent(viewContainerRef: ViewContainerRef): void {
        viewContainerRef.clear();
    }

    public showComponent(viewContainerRef: ViewContainerRef, templateRef: TemplateRef<unknown>): void {
        viewContainerRef.clear();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        viewContainerRef.createEmbeddedView(templateRef).rootNodes[0];
    }
}
